const Strings = {
  UNAUTHORIZED: {
    SE: 'Inloggning misslyckades',
    EN: 'Login failed'
  },
  UNAUTHORIZED_INFO: {
    SE: 'Email och lösenord matchar ej, var god försök igen.',
    EN: 'Email and password does not match, please try again.'
  },
  INTERNAL_ERROR: {
    SE: 'Oväntat fel',
    EN: 'Unexpected error'
  },
  NO_JANITOR: {
    SE: 'Ingen vaktmästare',
    EN:
      'Ingen vaktmästare har angivits, vänligen kontakta din förvaltare/ansvarig angående detta.'
  },
  INTERNAL_ERROR_INFO: {
    SE: 'Ett oväntat fel har uppstått, var god försök igen.',
    EN: 'An unexpected error has occured, please try again.'
  },
  LAUNDRY_TIME_OCCUPIED: {
    SE: 'Tiden är upptagen',
    EN: 'Time is occupied'
  },
  LAUNDRY_TIME_OCCUPIED_INFO: {
    SE: 'Tiden är redan bokad, var god välj ett annat pass.',
    EN: 'The time is already booked, please choose another one.'
  },
  MAX_BOOKINGS_REACHED: {
    SE: 'Max bokningar uppnått',
    EN: 'Max bookings reached'
  },
  MAX_BOOKINGS_REACHED_INFO: {
    SE:
      'Din förening tillåter inte fler bokningar, var god avboka en tid och försök igen.',
    EN:
      'You association does not allow more bookings, please unbook a time and try again.'
  },
  OK: {
    SE: 'Okej',
    EN: 'Okey'
  },
  EMAIL_IN_USE: {
    SE: 'Email redan i bruk',
    EN: 'Email already in use'
  },
  EMAIL_IN_USE_INFO: {
    SE: 'Emailadressen är redan i bruk, var god välj en annan email.',
    EN: 'The email is already in use, please enter another email.'
  },
  APARTMENT_NUMBER_IN_USE: {
    SE: 'Lägenhetsnummer redan i bruk',
    EN: 'Apartment number already in use'
  },
  APARTMENT_NUMBER_IN_USE_INFO: {
    SE:
      'Lägenhetsnumret är redan i bruk, var god välj ett annat lägenhetsnummer.',
    EN:
      'The apartment number is already in use, please enter another apartment numer.'
  },
  RESET_PASSWORD_EMAIL_SEND: {
    SE: 'Ett återställningsmail har skickats',
    EN: 'A reset password mail has been send'
  },
  RESET_PASSWORD_EMAIL_SEND_INFO: {
    SE:
      'Ett mail med instruktioner om hur du återställer ditt lösenord har skickats till den angivna emailadressen om den finns i vårt system.',
    EN:
      'An email with instructions about how to reset your password has been send to the entered email if it exists in our system.'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/actions/strings.js